export const GET_ALL_BOOKS = 'GET_ALL_BOOKS';
export const GET_BOOKS_RATING = 'GET_BOOKS_RATING';
export const GET_BOOKS_BY_NAME = 'GET_BOOKS_BY_NAME';
export const GET_BOOK_BY_ID = 'GET_BOOK_BY_ID';
export const GET_BOOK_BY_GENRE = 'GET_BOOK_BY_GENRE';
export const GET_GENRE = 'GET_GENRE';
export const GET_YEARS = 'GET_YEARS';
export const GET_BOOKS_BY_YEARS = 'GET_BOOKS_BY_YEARS';
export const USER_ROLE = 'USER_ROLE';
export const GET_ALL_USERS = 'GET_ALL_USERS';
export const GET_USER = 'GET_USER';
export const GET_USERS_BY_NAME = 'GET_USERS_BY_NAME';
export const GET_PRICE_ITEM = 'GET_PRICE_ITEM';
export const SUM_COUNT_ITEM = 'SUM_COUNT_ITEM';
export const LESS_COUNT_ITEM = 'LESS_COUNT_ITEM';
export const USER_CART = 'USER_CART';
export const DELETE_CART_BOOK = 'DELETE_CART_BOOK';
export const ORDER_BY_NAME = 'ORDER_BY_NAME';
export const ORDER_BY_BOOKS = 'ORDER_BY_BOOKS';
export const BOOK_DETAIL = 'BOOK_DETAIL';
export const GET_SESSION_ID = 'GET_SESSION_ID';
export const SOLD_OUT = 'SOLD_OUT';
export const CLEAN_UP_DETAIL = 'CLEAN_UP_DETAIL';
export const DELETE_ALL_CART_BOOKS = 'DELETE_ALL_CART_BOOKS';
export const GET_USER_PANEL = 'GET_USER_PANEL';
export const GET_BOOKS_PANEL = 'GET_BOOKS_PANEL';
export const GET_DETAIL_BOOK_PANEL = 'GET_DETAIL_BOOK_PANEL';
export const USER_FAVO = 'USER_FAVO';
export const DELETE_FAVO_BOOK = 'DELETE_FAVO_BOOK';
export const DELETE_ALL_FAVO_BOOKS = 'DELETE_ALL_FAVO_BOOKS';
export const GET_ALL_USER_ORDERS = 'GET_ALL_USER_ORDERS';
export const BUTTON_STATUS = 'BUTTON_STATUS'
export const GET_USER_ORDERS_BY_ID = 'GET_USER_ORDERS_BY_ID'
export const GET_ALL_USER_SALES = 'GET_ALL_USER_SALES';
export const GET_USER_SALES_BY_ID = 'GET_USER_SALES_BY_ID';
export const GET_TIMER = 'GET_TIMER'
